/**
 * LoanSummaryCards — extracted from LoansPage during Iter28 refactor.
 *
 * Pure presentational. Receives the loan summary payload from
 * /api/reports/loan-summary and renders the 4 stat cards.
 */
import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Landmark, TrendingUp, Wallet, User } from 'lucide-react';
import { formatCurrency } from '../../lib/utils';

const SummaryCard = ({ tone, Icon, label, value, valueClass = '', testid }) => (
  <Card className="card-hover" data-testid={testid}>
    <CardContent className="p-6">
      <div className="flex items-center gap-4">
        <div className={`p-3 rounded-xl ${tone}`}>
          <Icon className="h-6 w-6" />
        </div>
        <div>
          <p className="text-sm text-muted-foreground">{label}</p>
          <p className={`text-2xl font-heading font-bold ${valueClass}`}>{value}</p>
        </div>
      </div>
    </CardContent>
  </Card>
);

const LoanSummaryCards = ({ summary }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="loan-summary-cards">
    <SummaryCard
      Icon={(p) => <Landmark {...p} className="h-6 w-6 text-blue-600" />}
      tone="bg-blue-50 dark:bg-blue-900/20"
      label="Total Issued"
      value={formatCurrency(summary?.total_loans_issued || 0)}
      testid="loan-stat-issued"
    />
    <SummaryCard
      Icon={(p) => <TrendingUp {...p} className="h-6 w-6 text-green-600" />}
      tone="bg-green-50 dark:bg-green-900/20"
      label="Total Repaid"
      value={formatCurrency(summary?.total_repaid || 0)}
      valueClass="text-green-600"
      testid="loan-stat-repaid"
    />
    <SummaryCard
      Icon={(p) => <Wallet {...p} className="h-6 w-6 text-orange-600" />}
      tone="bg-orange-50 dark:bg-orange-900/20"
      label="Outstanding"
      value={formatCurrency(summary?.outstanding_balance || 0)}
      valueClass="text-orange-600"
      testid="loan-stat-outstanding"
    />
    <SummaryCard
      Icon={(p) => <User {...p} className="h-6 w-6 text-purple-600" />}
      tone="bg-purple-50 dark:bg-purple-900/20"
      label="Active Borrowers"
      value={summary?.active_borrowers || 0}
      testid="loan-stat-active"
    />
  </div>
);

export default LoanSummaryCards;
